// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Footer_Footer__-yeUI {
  left: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  margin-top: 50px;
  padding: 50px 50px;
  
}

.Footer_BackgroundFooter__bENUi {
  /* background: linear-gradient(120deg, #eee, #fff 100%); */
  width: 100%;
  min-height: 10vh;
  background-size: cover;
}

.Footer_Hr__FUP29 {
  height: 2px;
  background: linear-gradient(to right, #44AA99 0%, #332288 100%);
  border: 0px;
  margin-bottom: 40px;
}

.Footer_Text__1bWU2 {
  font-size: 12px; 
}

.Footer_Footer__-yeUI a {
  
  color: #000;
  text-decoration: underline;
}
.Footer_Footer__-yeUI a:hover{
  color: #30CFD0;
  text-decoration: underline;
}
.Footer_Push__0QzeT {
  margin-left: auto;
}
@media screen and (max-width: 500px) {
  .Footer_Footer__-yeUI a {
    float: none;
    display: block;
    text-align: left;
  }
  
  .Footer_FooterRight__nSjcR {
    float: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layout/Footer/Footer.module.css"],"names":[],"mappings":";AACA;EACE,OAAO;EACP,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,0DAA0D;EAC1D,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,+DAA+D;EAC/D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["\n.Footer {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  overflow: hidden;\n  margin-top: 50px;\n  padding: 50px 50px;\n  \n}\n\n.BackgroundFooter {\n  /* background: linear-gradient(120deg, #eee, #fff 100%); */\n  width: 100%;\n  min-height: 10vh;\n  background-size: cover;\n}\n\n.Hr {\n  height: 2px;\n  background: linear-gradient(to right, #44AA99 0%, #332288 100%);\n  border: 0px;\n  margin-bottom: 40px;\n}\n\n.Text {\n  font-size: 12px; \n}\n\n.Footer a {\n  \n  color: #000;\n  text-decoration: underline;\n}\n.Footer a:hover{\n  color: #30CFD0;\n  text-decoration: underline;\n}\n.Push {\n  margin-left: auto;\n}\n@media screen and (max-width: 500px) {\n  .Footer a {\n    float: none;\n    display: block;\n    text-align: left;\n  }\n  \n  .FooterRight {\n    float: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Footer": `Footer_Footer__-yeUI`,
	"BackgroundFooter": `Footer_BackgroundFooter__bENUi`,
	"Hr": `Footer_Hr__FUP29`,
	"Text": `Footer_Text__1bWU2`,
	"Push": `Footer_Push__0QzeT`,
	"FooterRight": `Footer_FooterRight__nSjcR`
};
export default ___CSS_LOADER_EXPORT___;
